import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Search, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Betriebs-Feld mit Vorschlägen aus der Kundenkartei. */
export const CustomerPicker = ({ pwd, value, onChange, onSelect, placeholder = "Betrieb / Name des Kunden", testId = "customer-picker", className = "" }) => {
  const [open, setOpen] = useState(false);
  const [hits, setHits] = useState([]);
  const box = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 2) { setHits([]); return; }
    let cancelled = false;
    const t = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/admin/kunden`, {
          params: { q }, headers: { "X-Admin-Password": pwd },
        });
        if (!cancelled) setHits((data || []).slice(0, 6));
      } catch { /* Vorschläge sind optional */ }
    }, 220);
    return () => { cancelled = true; clearTimeout(t); };
  }, [value, pwd]);

  const pick = (k) => {
    onSelect?.(k);
    setOpen(false);
  };

  return (
    <div ref={box} className={`relative ${className}`}>
      <input
        type="text"
        value={value || ""}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        data-testid={testId}
        autoComplete="off"
        className="w-full bg-white border border-[#E3DECE] focus:outline-none focus:border-[#BA6D52] px-3 py-3 text-sm"
      />
      {open && hits.length > 0 && (
        <div data-testid={`${testId}-suggestions`}
          className="absolute z-30 left-0 right-0 mt-1 bg-white border border-[#BA6D52] shadow-lg max-h-64 overflow-y-auto">
          <div className="flex items-center justify-between px-3 py-2 border-b border-[#E3DECE] bg-[#FAFAF7]">
            <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.15em] text-[#BA6D52]">
              <Search size={11} /> Aus Kundenkartei
            </span>
            <button type="button" onClick={() => setOpen(false)} className="text-[#757067] hover:text-[#BA6D52]">
              <X size={13} />
            </button>
          </div>
          {hits.map((k) => (
            <button
              key={k.id}
              type="button"
              onClick={() => pick(k)}
              data-testid={`${testId}-option-${k.id}`}
              className="w-full text-left px-3 py-2.5 hover:bg-[#FAF5F1] border-b border-[#F2EFE9] last:border-b-0"
            >
              <span className="block text-sm text-[#2C2A26]">{k.betrieb}</span>
              <span className="block text-xs text-[#757067]">
                {[k.ansprechpartner, k.ort, k.telefon].filter(Boolean).join(" · ") || k.email || "—"}
                {k.stundensatz_eur > 0 && ` · ${Number(k.stundensatz_eur).toFixed(2).replace(".", ",")} €/h`}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
